import React from "react";
import { IoMdArrowRoundBack } from "react-icons/io";
import { To, useNavigate } from "react-router-dom";
import "./Header.css"

export interface Props {
    title: String
    route?: String
}

export function Header({title, route}: Props) {
  const navigate = useNavigate();

  const handleBackButton = () => {
    if (route) {
    navigate(route as To);
    } else {
      navigate(-1)
    }
  };
  return (
    <div className="Header">
      <IoMdArrowRoundBack className="backIcon" onClick={handleBackButton} />
      <h1>{title}</h1>
    </div>
  );
}
